import {useCallback, useState} from 'react';
import {useEventGiftingClassifiedCategory} from '~/CreateFabricInvitation/routes/EventGifting/useEventGiftingClassifiedCategory';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {RegistryItem} from './RegistryItem';

import './RegistryList.sass';

type RegistryItemRecord = {
  id: string;
  value: string;
};

type RegistryListProps = {
  onChangeUrls: (newUrls: string[]) => void;
  urls: string[];
};

export const RegistryList = ({onChangeUrls, urls}: RegistryListProps) => {
  const {isWeddingEvent, isBabyEvent} = useEventGiftingClassifiedCategory();

  const [localUrls, setLocalUrls] = useState<RegistryItemRecord[]>(() => {
    if (urls?.length === 0) {
      return [{id: crypto.randomUUID(), value: ''}];
    }

    return urls.map((regUrl: string) => ({
      id: crypto.randomUUID(),
      value: regUrl,
    }));
  });

  const onChangeRegistryHandler = useCallback(
    (id: string, newValue: string) => {
      const temp = [...localUrls];
      const registry = temp.find((reg) => reg.id === id);
      if (registry) {
        registry.value = newValue;
      }

      setLocalUrls(temp);

      onChangeUrls(temp.filter((reg) => reg.value !== '').map((reg) => reg.value));
    },
    [localUrls, onChangeUrls]
  );

  const onClickDeleteHandler = useCallback(
    (id: string) => {
      const urlsFiltered = localUrls.filter((reg) => reg.id !== id);

      setLocalUrls(urlsFiltered);

      onChangeUrls(urlsFiltered.map((reg) => reg.value));
    },
    [localUrls, onChangeUrls]
  );

  const handleAddRegistryClick = useCallback(() => {
    setLocalUrls((prevState) => [...prevState, {id: crypto.randomUUID(), value: ''}]);
  }, []);

  let inputLabel = 'Wishlist links*';

  if (isWeddingEvent || isBabyEvent) {
    inputLabel = 'Registry links*';
  }

  return (
    <div className="registry-list">
      <Typography variant="label2" className="input-label" semibold>
        {inputLabel}
      </Typography>

      <div className="registry-list__items">
        {localUrls.map((registry: RegistryItemRecord, index: number) => (
          <RegistryItem
            key={registry.id}
            firstItem={index === 0}
            id={registry.id}
            value={registry.value}
            onDelete={onClickDeleteHandler}
            hideDeleteButton={localUrls.length === 1}
            onChange={onChangeRegistryHandler}
          />
        ))}
      </div>

      {localUrls.length >= 1 && localUrls.length < 3 && (
        <Button
          variant="link"
          size="small"
          data-qa-id="add-another"
          onClick={handleAddRegistryClick}
          type="button"
          className="registry-list__add-another"
        >
          + Add another
        </Button>
      )}
    </div>
  );
};
